export interface PDIProject {
  title: string;
  summary: string;
  period: string;
}

export interface ConsultingOffer {
  title: string;
  duration: string;
  description: string;
  image: string;
  path: string;
}

export interface ConsultingSegment {
  title: string;
  description: string;
}

export interface ConsultingStep {
  number: string;
  title: string;
  description: string;
}

const pendingSummary = 'Resumo do projeto a ser informado pela Faculdade.';
const pendingPeriod = 'Período/data a ser informado pela Faculdade.';

export const pdiProjects: PDIProject[] = [
  {
    title: 'Guia Virtual - Manaus na palma da mão',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Elaboração de molho de pimenta tipo tabasco a partir da fermentação láctica de pimenta ova-de-aruanã (Capsicum sp.)',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Culinária Amazônica: Receita autoral de pastel com sabor regional.',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Conserva de bodó: o cardápio do Amazonas com o recheio do cascudo de água doce.',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Delícias do Moquém: sustentabilidade, lazer e gastronomia',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Restaurante Iara: Gastronomia com sabor amazônico',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Vela hidratante: cosmético com ativo regional para uso na Podologia',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Massageador de tucumã pedimassagem: uma proposta para auxiliar nas técnicas de massagem nos pés',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'O potencial dos óleos essenciais no combate a onicomicose',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Pomada Podológica da Amazônia à base de jucá',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Plano podológico para saúde preventiva',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Massageador Murutu: uma proposta para auxiliar nas aplicações e técnicas de massagem no atendimento de Podologia',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Estética Paliativa',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Elaboração de e-book sobre endolaser na Estética como ferramenta informativa.',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Clínica de Estética voltada a mulheres na menopausa',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Pré e Pós-Depilação: Cosméticos calmantes com jambu para pelo',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Terapia capilar com óleo de andiroba no eflúvio telógeno',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Foliculite: Tratamento Corporal Fitoterápico - Gel hidratante com copaíba, camomila e rosa mosqueta',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'A eficácia da máscara capilar com óleo de buriti na hidratação para todos os tipos de cabelo',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Camu-camu: cosméticos com ativo regional para uso home care',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Massageador Tucumanauara',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Beauty Schedule: aplicativo móvel de gestão e cronograma estética',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Liss Setibelle: Chapinha portátil recarregável USB',
    summary: pendingSummary,
    period: pendingPeriod,
  },
  {
    title: 'Estetiquinze: Serviços de Estética e Beleza para debutantes',
    summary: pendingSummary,
    period: pendingPeriod,
  },
];

export const consultingOffers: ConsultingOffer[] = [
  {
    title: 'Agentes de Inovação',
    duration: '40h',
    description: 'Consultoria para início da cultura de soluções inovadoras em sua empresa.',
    image: '/assets/consultoria/card agente de inovação.png',
    path: '/pesquisa-inovacao/solucoes-inovadoras-para-empresas/agentes-de-inovacao',
  },
  {
    title: 'Empresa Digital',
    duration: '40h',
    description: 'Consultoria para soluções em atendimentos automatizados com IA.',
    image: '/assets/consultoria/card Empresa Digital.png',
    path: '/pesquisa-inovacao/solucoes-inovadoras-para-empresas/empresa-digital',
  },
  {
    title: 'IA para Executivos',
    duration: '32h',
    description: 'Consultoria para implementação de soluções de IA para executivos.',
    image: '/assets/consultoria/card IA para executivos.png',
    path: '/pesquisa-inovacao/solucoes-inovadoras-para-empresas/ia-para-executivos',
  },
  {
    title: 'IA para Otimização de Processos Internos',
    duration: '40h',
    description: 'Consultoria para aplicar IA na melhoria e automação de processos internos.',
    image: '/assets/consultoria/card IA para Otimização de Processos Internos.png',
    path: '/pesquisa-inovacao/solucoes-inovadoras-para-empresas/ia-otimizacao-processos-internos',
  },
];

export const consultingSegments: ConsultingSegment[] = [
  {
    title: 'Gestão e Finanças',
    description: 'Mais eficiência e integração para o seu time.',
  },
  {
    title: 'Comércio',
    description: 'Estratégias para vender mais e melhor.',
  },
  {
    title: 'Tecnologia da Informação',
    description: 'Segurança e inovação para crescer com tecnologia.',
  },
  {
    title: 'Gastronomia',
    description: 'Formação de preços, estoque e atendimento impecável.',
  },
  {
    title: 'Beleza',
    description: 'Novas tendências para atrair e fidelizar clientes.',
  },
  {
    title: 'Saúde',
    description: 'Inovação, biossegurança e gestão eficiente.',
  },
  {
    title: 'Turismo',
    description: 'Estratégias e soluções para impulsionar negócios e atrair visitantes.',
  },
  {
    title: 'Design',
    description: 'Criatividade e impacto visual para destacar sua marca.',
  },
  {
    title: 'Meio Ambiente',
    description: 'Práticas sustentáveis para reduzir impactos e valorizar seu negócio.',
  },
];

export const consultingSteps: ConsultingStep[] = [
  {
    number: '01',
    title: 'Identificação do Problema',
    description: 'Realizamos uma reunião inicial para entender suas dificuldades e mapear a situação atual.',
  },
  {
    number: '02',
    title: 'Planejamento Personalizado',
    description: 'Criamos, em conjunto, uma estratégia focada em resolver os desafios encontrados.',
  },
  {
    number: '03',
    title: 'Execução das Ações',
    description: 'Colocamos o plano em funcionamento e acompanhamos de perto o progresso das atividades.',
  },
  {
    number: '04',
    title: 'Entrega de Resultados',
    description: 'Apresentamos um relatório final com as melhorias e os ganhos obtidos pelo seu negócio.',
  },
];

export const obtecBenefits = [
  {
    title: 'Leitura de Cenário',
    description: 'Organiza informações relevantes para acompanhar movimentos, oportunidades e tendências do comércio.',
  },
  {
    title: 'Apoio ao Planejamento',
    description: 'Converte dados em insumos úteis para decisões institucionais, estratégicas e operacionais.',
  },
  {
    title: 'Inteligência para Decisão',
    description: 'Favorece análises mais consistentes para orientar ações, projetos e prioridades.',
  },
];

export const obtecHighlights = [
  {
    value: 'OBTEC',
    label: 'Observatório de Tecnologias do Comércio',
  },
  {
    value: 'Centro',
    label: 'Território inicial de atuação em Manaus',
  },
  {
    value: 'BI',
    label: 'Painéis interativos para análise estratégica',
  },
  {
    value: 'Dados',
    label: 'Diagnósticos e indicadores de maturidade digital',
  },
];

export const obtecObjectives = [
  {
    title: 'Diagnosticar',
    description:
      'Avaliar o nível de maturidade digital das empresas, por meio da aplicação de questionários e análises que permitam entender como a tecnologia é utilizada no dia a dia, em vendas, atendimento, gestão e outros processos.',
  },
  {
    title: 'Mapear',
    description:
      'Identificar e organizar as principais tecnologias utilizadas pelas empresas do comércio local, como redes sociais, sistemas de gestão e vendas online, oferecendo uma visão clara das práticas adotadas no mercado.',
  },
  {
    title: 'Desenvolver',
    description:
      'Criar indicadores territoriais de inovação que permitam acompanhar o nível de desenvolvimento digital por bairro, apoiando análises comparativas e a identificação de oportunidades de crescimento.',
  },
  {
    title: 'Disponibilizar',
    description:
      'Oferecer dados e informações em uma plataforma digital acessível, por meio de painéis interativos com gráficos, indicadores e comparativos que facilitam a compreensão do cenário do comércio.',
  },
  {
    title: 'Promover',
    description:
      'Fomentar a capacitação e a inovação aberta, por meio da realização de eventos, conexões com especialistas e acesso a soluções tecnológicas que apoiam a evolução das empresas.',
  },
  {
    title: 'Impulsionar',
    description:
      'Contribuir para o desenvolvimento econômico sustentável do comércio, apoiando o crescimento das empresas com o uso da tecnologia para aumentar vendas, melhorar processos e fortalecer a competitividade.',
  },
];

export const obtecTechnologies = [
  {
    title: 'BIG DATA',
    subtitle: 'Análise e processamento de grandes volumes de dados',
    description:
      'O Big Data refere-se à capacidade de coletar, processar e analisar grandes volumes de dados provenientes de múltiplas fontes, como sistemas de vendas, comportamento do consumidor, redes sociais e dispositivos digitais.',
    impact:
      'No comércio, transforma dados brutos em informações estratégicas, apoia a tomada de decisão, identifica padrões de consumo, prevê demandas, personaliza ofertas e otimiza operações.',
  },
  {
    title: 'BLOCKCHAIN',
    subtitle: 'Tecnologia de registro distribuído',
    description:
      'O blockchain permite armazenar informações de forma segura, transparente e imutável. No comércio, sua aplicação está relacionada à rastreabilidade de produtos, contratos inteligentes e transações digitais.',
    impact:
      'Essa tecnologia contribui para aumentar a confiança nas operações e reduzir fraudes, especialmente em contextos que exigem transparência e segurança.',
  },
  {
    title: 'CIBERSEGURANÇA',
    subtitle: 'Proteção de dados e sistemas',
    description:
      'A cibersegurança envolve práticas e tecnologias voltadas à proteção de sistemas, redes e dados contra ameaças digitais. Com o avanço da digitalização, empresas do comércio tornam-se cada vez mais dependentes de ambientes digitais.',
    impact:
      'A adoção de medidas de segurança é essencial para garantir a confiança dos clientes, a integridade das operações e a conformidade com legislações como a LGPD.',
  },
  {
    title: 'COMPUTAÇÃO EM NUVEM',
    subtitle: 'Infraestrutura escalável e flexível',
    description:
      'A computação em nuvem permite o acesso remoto a sistemas, dados e infraestrutura tecnológica por meio da internet, eliminando a necessidade de investimentos elevados em servidores físicos.',
    impact:
      'No setor comercial, viabiliza gestão de estoques e vendas, integração de sistemas e plataformas digitais, além de maior flexibilidade, escalabilidade e redução de custos operacionais.',
  },
  {
    title: 'COMPUTAÇÃO QUÂNTICA',
    subtitle: 'Computação de próxima geração',
    description:
      'A computação quântica representa uma nova fronteira tecnológica, baseada em princípios da mecânica quântica para processar informações de forma muito mais rápida do que os computadores tradicionais.',
    impact:
      'Embora ainda emergente, possui potencial para aplicações futuras em otimização logística, análise avançada de dados e segurança da informação.',
  },
  {
    title: 'INTERNET DAS COISAS (IoT)',
    subtitle: 'Conectividade e sensores para monitoramento',
    description:
      'A Internet das Coisas conecta dispositivos físicos à internet, permitindo a coleta e troca de dados em tempo real. No comércio, aparece em sensores de estoque, monitoramento de ambientes, rastreamento logístico e automação de processos.',
    impact:
      'A adoção de IoT proporciona maior controle operacional, redução de perdas e melhoria na gestão de recursos.',
  },
  {
    title: 'INTELIGÊNCIA ARTIFICIAL',
    subtitle: 'Sistemas inteligentes para automação e decisão',
    description:
      'A Inteligência Artificial consiste no desenvolvimento de sistemas capazes de simular a inteligência humana, realizando tarefas como análise de dados, reconhecimento de padrões, tomada de decisão e automação de processos.',
    impact:
      'No comércio, apoia personalização de experiências, atendimento automatizado, análise preditiva, eficiência operacional e ampliação de estratégias de vendas.',
  },
  {
    title: 'ROBÓTICA',
    subtitle: 'Automação de processos e operações',
    description:
      'A robótica envolve o uso de máquinas e sistemas automatizados para executar tarefas de forma autônoma ou semiautônoma. No comércio, está presente principalmente em centros de distribuição, logística e processos operacionais repetitivos.',
    impact:
      'A utilização de robôs contribui para aumento da produtividade, redução de erros e otimização de processos.',
  },
];

export const obtecIndicators = [
  {
    title: 'Presença Digital',
    description:
      'Avalia o nível de posicionamento das empresas no ambiente digital, considerando visibilidade online, uso de canais digitais e estratégias de comunicação para atração de clientes.',
  },
  {
    title: 'Vendas Digitais',
    description:
      'Analisa a utilização de canais digitais para comercialização, incluindo e-commerce, marketplaces e outras estratégias que ampliam a geração de receita no ambiente online.',
  },
  {
    title: 'Experiência do Cliente',
    description:
      'Examina como as empresas utilizam canais digitais para relacionamento, atendimento e fidelização, com foco na qualidade da jornada do cliente.',
  },
  {
    title: 'Gestão e Uso de Dados',
    description:
      'Avalia a capacidade das empresas de coletar, analisar e utilizar dados para apoiar a tomada de decisão, melhorar processos e orientar estratégias de negócio.',
  },
  {
    title: 'Operações e Logística',
    description:
      'Analisa o uso de tecnologias para otimização de processos operacionais, gestão de estoques e eficiência nas entregas.',
  },
  {
    title: 'Segurança e Governança de Dados',
    description:
      'Avalia práticas de proteção de dados, conformidade com regulamentações e uso responsável das informações no contexto digital.',
  },
  {
    title: 'Tecnologias e Inovação',
    description:
      'Examina o nível de adoção de tecnologias emergentes, como Inteligência Artificial e automação, voltadas à modernização e competitividade do negócio.',
  },
];

export const obtecPublications = [
  {
    title: 'Relatórios Técnicos',
    description:
      'Análises aprofundadas sobre tendências digitais, comportamento do mercado e adoção de tecnologias no comércio. Ideal para entender o cenário e tomar decisões estratégicas.',
  },
  {
    title: 'Diagnósticos Setoriais',
    description:
      'Estudos sobre o nível de maturidade digital por segmento, permitindo comparar sua empresa com o mercado. Identifique onde você está e como evoluir.',
  },
  {
    title: 'Estudos Aplicados',
    description:
      'Pesquisas com foco prático, apresentando soluções e oportunidades reais para o comércio. Conteúdos que podem ser aplicados diretamente no seu negócio.',
  },
  {
    title: 'Manual de Boas Práticas',
    description:
      'Guias práticos com orientações para adoção de tecnologias, melhoria de processos e transformação digital. Passo a passo para implementar melhorias no seu negócio.',
  },
];
